export enum FeatureFlag {
	SfauthEnableIdentityPilet = 'sfauth-enable-identity-pilet',
	SessionEnabled = 'sfauth_enable_session_mgmt_pilet',
	EnableOTP = 'enable_otp',
}
